import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useEffect, useState } from "react";
import { GeneralService } from "../../../services/GeneralService";
import { GlobalService } from "../../../services/GlobalService";
import { toast } from "react-toastify";

export default function ShareInterviewModal({
  interviewId,
  isOpen,
  onClose,
  createInterviewInOtherCompany
}) {
  const [companies, setCompanies] = useState([]);
  const [request, setRequest] = useState({ sourceInterviewId: interviewId });

  let { t } = useTranslation();
  useEffect(() => {
    GeneralService.getAllUserCompanies().then((data) => {
      setCompanies(data);
    });
  }, []);
  function onChange({ target }) {
    setRequest({ ...request, [target.name]: target.value });
  }

  return (
    <ModalContainer
      modalTitle={t("Share interview to company")}
      isOpen={isOpen}
      submitButtonAction={() => createInterviewInOtherCompany(request)}
      submitButtonTitle={t("Save")}
      submitButtonType="button"
      cancelButtonAction={onClose}
      cancelButtonTitle={t("Cancel")}
      closeModal={onClose}
      crossmarkAction={onClose}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="company">{t("Company")}</label>
        </div>

        <select
          className="form-control"
          id="company"
          onChange={onChange}
          value={request.destinationComapnyId}
          name="destinationComapnyId"
        >
          <option value="">{t("Select company...")}</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          ))}
        </select>
      </div>
    </ModalContainer>
  );
}
